<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';

	//Stores

	//Helpers
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';

	//Types
	import type { Device } from '../../../../../types/Device';
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	import type { InputClickEvent } from '../../../../../types/InputClickEvent';

	//Design system components
	import { Toggle, Alert } from '@Shelly/shelly-design-system';
	export let device: Device;

	const settings = readDeviceSettings(device.id);
	let enabled = settings['thermostats'][0].ext_t.floor_heating;
	let loading = false;

	const sendRequest = async (e: InputClickEvent): Promise<void> => {
		loading = true;
		enabled = e.target.checked;
		const res: SettingRequest = await postReq(
			`/device/generic_command`,
			{
				id: device.id,
				command: `ext_t`,
				payload: JSON.stringify({
					id: device.channel,
					floor_heating: enabled,
					enabled,
				}),
			},
			20000,
		);

		if (!res?.isok) {
			enabled = !enabled;
		}

		onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Toggle
	class="mb-s"
	size="m"
	disabled={loading}
	checked={enabled}
	on:click={sendRequest}
	id="toggle-y091pw7"
>
	{$format('enable', {
		default: 'Enable',
	})}
</Toggle>

<Alert
	heading={$format('under_floor_heating_description', {
		default:
			'Only the data from the external sensor is valid, without taking into calculations from the build-in one.',
	})}
/>
